import React, { useState, useEffect } from "react";
import {
  Tooltip,
  OverlayTrigger,
  Button,
  Form,
  Pagination,
} from "react-bootstrap";
import Data from "../../file/DataDummy-Test-Table.json";
import { CloseFullscreen, SendTimeExtension } from "@mui/icons-material";
import { filter } from "jszip";
import { AiOutlineClear } from "react-icons/ai";
import { RiMenuSearchLine } from "react-icons/ri";
//วิธีใช้
// 1. แปะ
// const [portionToMaps, setPortionToMaps] = useState([]);
// const [startArr,setStartArr]= useState(0);
// const handlePortionChange = (newPortion,startarr) => {
//   console.log(newPortion,startarr)
//   setPortionToMaps(newPortion);
//   setStartArr(startarr);
// };
//  2. แปะ html ตามที่ต้องการ   datatest = ข้อมูลทั้งหมด(array)
/// <PaginationS data={datatest}  onPortionChange={handlePortionChange} />

const PaginationS = (props) => {
  /// Pagination Variable
  const dataDummy = props.data;
  const [perPage, setPerPage] = useState(5);
  //const [checkPerPage, setCheckPerPage] = useState(5);
  const [thisPage, setThisPage] = useState(1);
  const [startArr, setStartArr] = useState(0);
  const [endArr, setEndArr] = useState(perPage);
  const [startPage, setStartPage] = useState(1);
  const [endPage, setEndPage] = useState();
  const portionToMap = dataDummy.slice(startArr, endArr);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState(props.searchValue);

  const sendAnotherComponents = (portion, startarr) => {
    props.onPortionChange(portion, startarr);
  };
  const handleControlPage = (element, thisPage) => {
    if (searchTerm !== "") {
      if (element === "First") {
        setThisPage(1);
        setStartArr(0);
        setEndArr(perPage);
        sendAnotherComponents(filteredData.slice(0, perPage), 0);
      } else if (element === "Last") {
        if (filteredData.length % perPage !== 0) {
          setStartArr(parseInt(filteredData.length / perPage) * perPage);
          setEndArr(filteredData.length);
          setThisPage(endPage);
          sendAnotherComponents(
            filteredData.slice(
              parseInt(filteredData.length / perPage) * perPage,
              filteredData.length
            ),
            parseInt(dataDummy.length / perPage) * perPage
          );
        } else {
          setStartArr(filteredData.length - perPage);
          setEndArr(filteredData.length);
          setThisPage(endPage);
          sendAnotherComponents(
            filteredData.slice(
              filteredData.length - perPage,
              filteredData.length
            ),
            filteredData.length - perPage
          );
        }
      } else if (element === "Next" && thisPage < endPage) {
        setStartArr(thisPage * perPage);
        setEndArr((thisPage + 1) * perPage);
        setThisPage(thisPage + 1);
        sendAnotherComponents(
          filteredData.slice(thisPage * perPage, (thisPage + 1) * perPage),
          thisPage * perPage
        );
      } else if (element === "Previous" && thisPage > 1) {
        setStartArr((thisPage - 1) * perPage - perPage);
        setEndArr((thisPage - 1) * perPage);
        setThisPage(thisPage - 1);
        sendAnotherComponents(
          filteredData.slice(
            (thisPage - 1) * perPage - perPage,
            (thisPage - 1) * perPage
          ),
          (thisPage - 1) * perPage - perPage
        );
      } else if (element === "Select") {
        console.log("select:", (thisPage - 1) * perPage);
        setThisPage(thisPage);
        setStartArr((thisPage - 1) * perPage);
        setEndArr((thisPage - 1) * perPage + perPage);
        sendAnotherComponents(
          filteredData.slice(
            (thisPage - 1) * perPage,
            (thisPage - 1) * perPage + perPage
          ),
          (thisPage - 1) * perPage
        );
      }
    } else {
      if (element === "First") {
        setThisPage(1);
        setStartArr(0);
        setEndArr(perPage);
        sendAnotherComponents(dataDummy.slice(0, perPage), 0);
      } else if (element === "Last") {
        if (dataDummy.length % perPage !== 0) {
          setStartArr(parseInt(dataDummy.length / perPage) * perPage);
          setEndArr(dataDummy.length);
          setThisPage(endPage);
          sendAnotherComponents(
            dataDummy.slice(
              parseInt(dataDummy.length / perPage) * perPage,
              dataDummy.length
            ),
            parseInt(dataDummy.length / perPage) * perPage
          );
        } else {
          setStartArr(dataDummy.length - perPage);
          setEndArr(dataDummy.length);
          setThisPage(endPage);
          sendAnotherComponents(
            dataDummy.slice(dataDummy.length - perPage, dataDummy.length),
            dataDummy.length - perPage
          );
        }
      } else if (element === "Next" && thisPage < endPage) {
        setStartArr(thisPage * perPage);
        setEndArr((thisPage + 1) * perPage);
        setThisPage(thisPage + 1);
        sendAnotherComponents(
          dataDummy.slice(thisPage * perPage, (thisPage + 1) * perPage),
          thisPage * perPage
        );
      } else if (element === "Previous" && thisPage > 1) {
        setStartArr((thisPage - 1) * perPage - perPage);
        setEndArr((thisPage - 1) * perPage);
        setThisPage(thisPage - 1);
        sendAnotherComponents(
          dataDummy.slice(
            (thisPage - 1) * perPage - perPage,
            (thisPage - 1) * perPage
          ),
          (thisPage - 1) * perPage - perPage
        );
      } else if (element === "Select") {
        console.log("select:", (thisPage - 1) * perPage);
        setThisPage(thisPage);
        setStartArr((thisPage - 1) * perPage);
        setEndArr((thisPage - 1) * perPage + perPage);
        sendAnotherComponents(
          dataDummy.slice(
            (thisPage - 1) * perPage,
            (thisPage - 1) * perPage + perPage
          ),
          (thisPage - 1) * perPage
        );
      }
    }
  };

  const filteredData = dataDummy.filter((item) =>
    searchValue.some((key) =>
      item[key]?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );


  const handleSearchChange = () => {
    if (searchTerm !== "") {
      let dataDummy = filteredData;
      //setDataDummy(filteredData)
      props.onPortionChange(dataDummy.slice(0, perPage), 0);
    } else {
      handleControlPage("First", 1);
      props.onPortionChange(dataDummy.slice(0, perPage), 0);
    }
  };

  useEffect(() => {
    //เมื่อมีการเปลี่ยน PerPage ตรวจสอบจำนวนข้อมูล เพื่อหาหน้าสุดท้าย
    console.log("Eff => Pagi");
    if (searchTerm !== "") {
      if (filteredData.length === 0) {
        setEndPage(1);
        handleControlPage("First", 1);
        sendAnotherComponents(filteredData.slice(0, perPage), 0);
      } else {
        if (filteredData.length % perPage !== 0) {
          let checkendpage = parseInt(dataDummy.length / perPage) + 1;
          setEndPage(parseInt(filteredData.length / perPage) + 1);
          if (thisPage > checkendpage) {
            setThisPage(parseInt(filteredData.length / perPage) + 1);
          }
          handleControlPage("First", 1);
          sendAnotherComponents(filteredData.slice(0, perPage), 0);
        } else {
          setEndPage(parseInt(filteredData.length / perPage));
          handleControlPage("First", 1);
          sendAnotherComponents(filteredData.slice(0, perPage), 0);
        }
      }
    } else {
      if (dataDummy.length === 0) {
        setEndPage(1);
        handleControlPage("First", 1);
        sendAnotherComponents(dataDummy.slice(0, perPage), 0);
      } else {
        if (dataDummy.length % perPage !== 0) {
          let checkendpage = parseInt(dataDummy.length / perPage) + 1;
          setEndPage(parseInt(dataDummy.length / perPage) + 1);
          if (thisPage > checkendpage) {
            setThisPage(parseInt(dataDummy.length / perPage) + 1);
          }
          handleControlPage("First", 1);
          sendAnotherComponents(dataDummy.slice(0, perPage), 0);
        } else {
          setEndPage(parseInt(dataDummy.length / perPage));
          handleControlPage("First", 1);
          sendAnotherComponents(dataDummy.slice(0, perPage), 0);
        }
      }
    }
  }, [perPage, dataDummy, searchTerm]);
  const tooltipSearch = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      ค้นหา
    </Tooltip>
  );

  const tooltipClear = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      เคลียร์
    </Tooltip>
  );

  const beforeThisPage = (
    props // ปุ่มระหว่าง หน้าแรก ไปจนถึง ตำแหน่งหน้า
  ) => (
    <Tooltip id="button-tooltip" bsPrefix="contaniner-box" {...props}>
      <div
        style={{
          padding: "2px",
          width: "150px",
          margin: "auto",
          justifyContent: "center",
          display: "flex",
        }}
      >
        {[...Array(thisPage - 1).keys()].map((i) => {
          const number = i + 2;
          if (number < thisPage) {
            return (
              <Button
                key={number}
                onClick={() => handleControlPage("Select", number)}
                style={{ margin: "2px" }}
              >
                {number}
              </Button>
            );
          }
          return null;
        })}
      </div>
    </Tooltip>
  );

  const afterThisPage = (
    props // ปุ่มระหว่าง ตำแหน่งหน้า ไปจนถึง หน้าสุดท้าย
  ) => (
    <Tooltip id="button-tooltip" bsPrefix="contaniner-box" {...props}>
      <div
        style={{
          padding: "2px",
          width: "150px",
          margin: "auto",
          justifyContent: "center",
          display: "flex",
        }}
      >
        {[...Array(endPage).keys()].map((i) => {
          const number = i + thisPage + 1;
          if (thisPage > number || number < endPage) {
            return (
              <Button
                key={number}
                onClick={() => handleControlPage("Select", number)}
                style={{ margin: "2px" }}
              >
                {number}
              </Button>
            );
          }
          return null;
        })}
      </div>
    </Tooltip>
  );
  ///// Pagination

  return (
    <>
      <div
        style={{
          marginTop: "35px",
          justifyContent: "end",
          display: "flex",
        }}
      >
        <a style={{ marginRight: "15px" }}></a>
        <input
          type="text"
          placeholder="🔍  ค้นหา..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          className="form-input"
          style={{ marginRight: "15px", border: "1px solid gray" }}
        />
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={tooltipSearch}
        >
          <Button
            onClick={handleSearchChange}
            style={{
              marginRight: "15px",
              height: "38px",
              display: "flex",
              justifyItems: "center",
            }}
            variant="success"
          >
            <RiMenuSearchLine style={{ width: "25px", height: "25px" }} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={tooltipClear}
        >
          <Button
            onClick={(e) => {
              setSearchTerm("");
              handleSearchChange();
            }}
            style={{
              marginRight: "15px",
              height: "38px",
              display: "flex",
              justifyItems: "center",
            }}
            variant="danger"
          >
            <AiOutlineClear style={{ width: "25px", height: "25px" }} />
          </Button>
        </OverlayTrigger>
        <Form.Select
          aria-label="Default select example"
          style={{ width: "70px", height: "38px", marginRight: "20px" }}
          value={perPage}
          onChange={(e) => {
            //setPerPage(parseInt(e.target.value))
            setPerPage(parseInt(e.target.value));
          }}
        >
          <option disabled>จำนวน/หน้า</option>
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="15">15</option>
        </Form.Select>{" "}
        <Pagination>
          <Pagination.First
            onClick={() => handleControlPage("First", thisPage)}
          />
          <Pagination.Prev
            onClick={() => handleControlPage("Previous", thisPage)}
          />
          <Pagination.Item onClick={() => handleControlPage("First", thisPage)}>
            {startPage}
          </Pagination.Item>
          <OverlayTrigger
            trigger={"focus"}
            placement="bottom"
            delay={{ show: 400, hide: 600 }}
            overlay={beforeThisPage}
          >
            <Pagination.Ellipsis />
          </OverlayTrigger>
          <Pagination.Item active>{thisPage}</Pagination.Item>

          <OverlayTrigger
            trigger={"focus"}
            placement="bottom"
            delay={{ show: 400, hide: 0 }}
            overlay={afterThisPage}
          >
            <Pagination.Ellipsis />
          </OverlayTrigger>

          <Pagination.Item onClick={() => handleControlPage("Last", thisPage)}>
            {endPage}
          </Pagination.Item>
          <Pagination.Next
            onClick={() => handleControlPage("Next", thisPage)}
          />
          <Pagination.Last
            onClick={() => handleControlPage("Last", thisPage)}
          />
        </Pagination>
      </div>
    </>
  );
};
export default PaginationS;
